<template>
    <div>
        <div id="loadingScreen" class="loadingscreen"><img src="images/Spinner-1s-200px-1.gif" width="85" alt="">
            <div class="vertical-divider"></div><img src="images/rrp-logo.png" width="123" srcset="images/rrp-logo-p-500.png 500w, images/rrp-logo-p-800.png 800w, images/rrp-logo.png 845w" sizes="100vw" alt=""></div>
        <div id="Critical-Shortages" class="wrapper m0-50 critical">
            <div class="section">
                <div class="section-container">
                    <div class="columns-7 w-row">
                        <div class="w-col w-col-9 w-col-stack">
                            <div class="content4-headline-wrap">
                                <h6><strong class="bold-text-3">Manage Current Postings</strong></h6>
                                <div class="size1-text size1-top-clear">Your Active Posts<a href="https://prospero-uikit.webflow.io/2-content#"><strong><br></strong></a></div>
                                <p class="paragraph-73">Review matches and manage details for your offers and requests.</p>
                            </div>
                        </div>
                        <div class="column-12 w-col w-col-3 w-col-stack">
                            <div class="searchbox">
                                <div class="text-block-12">Search...</div>
                            </div>
                        </div>
                    </div>
                    <div data-duration-in="300" data-duration-out="100" class="w-tabs">
                        <div class="my-posts-tab-container w-tab-menu">
                            <a v-on:click="requestsTabClick()" data-w-tab="Tab 1" class="posts-tab-button my-requests w-inline-block w-tab-link" v-bind:class="{ 'w--current': this.demandTab }">
                                <div>My Requests</div>
                            </a>
                            <a v-on:click="offersTabClick()" data-w-tab="Tab 2" class="posts-tab-button offers w-inline-block w-tab-link" v-bind:class="{ 'w--current': this.offersTab }">
                                <div>My Offers</div>
                            </a>
                        </div>
                        <div class="w-tab-content">
                            <div data-w-tab="Tab 1" class="w-tab-pane w--tab-active" v-if="demandTab">
                                <div id="requestedSuppliesTable" class="shortages-table">
                                    <div class="w-dyn-list">
                                        <div v-if="this.demandPosts.length > 0" class="w-dyn-items">

                                            <div v-for="(demand, index) in this.demandPosts" :key="demand.id" class="w-dyn-item">
                                                <div data-w-id="ca21ac9f-737f-c9f4-eadd-ce9b6ba7d195" class="shortage-line-item top-item">
                                                    <div class="shortage-product-info">
                                                        <div class="div-block-24">
                                                            <div class="shortage-product">{{demand.product.description}}</div>
                                                            <div class="text-block-8">{{getMaterialName(demand)}}</div>
                                                            <div class="div-block-32">
                                                                <div class="more-information-shortage">Requested By: </div>
                                                                <div v-if="!demand.user.account.logoUrl" class="post-creator">{{demand.user.account.businessName}}</div>
                                                                <img v-if="demand.user.account.logoUrl" height="18" :src="demand.user.account.logoUrl" :alt="demand.user.account.businessName" class="supplier-logo">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="offer-shortage-materials-container">
                                                        <div class="row-container">
                                                            <div class="shortage-units"></div>
                                                            <div class="product-units-request"></div>
                                                        </div><a data-w-id="ca21ac9f-737f-c9f4-eadd-ce9b6ba7d1a3" href="#" v-on:click="manageRequestButtonClick(index)" class="offer-shortage-materials w-button">Manage Request</a>
                                                        <modal v-if="demandModal && demandIndex === index" class="match-modal-wrapper" style="opacity: 1; display: flex;">
                                                            <div class="modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                                                <div data-w-id="c957dc92-2424-8761-3cc1-f7905b1ac84f" class="close-modal-button"><img src="images/close.png" alt=""></div>
                                                                <div class="modal-title-container">
                                                                    <div>
                                                                        <div>{{demand.product.description}}</div>
                                                                        <div class="modal-header">{{getMaterialName(demand)}}</div>
                                                                        <div class="demand-container">
                                                                            <div>Requested: </div>
                                                                            <div class="shortage-units" style="margin-left: 5px;">{{demand.qtyRequiredNow}} {{getUnits(demand)}}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div v-on:click="manageRequestButtonClick()" data-w-id="0f61cdc8-0f02-cc9b-58cd-fab5413d5186" class="close-available-modal-button"><img src="../assets/images/close.png" alt=""></div>
                                                                </div>
                                                                <div class="modal-information-container">
                                                                    <div class="columns-5 w-row">
                                                                        <div class="column-9 w-col w-col-6">
                                                                            <div class="div-block-27">
                                                                                <div class="details-title">Requested by:</div>
                                                                                <div class="text-block-10">{{demand.user.account.businessName}}</div>
                                                                            </div>
                                                                            <div class="div-block-27">
                                                                                <div class="details-title">Contact:</div>
                                                                                <div class="text-block-10">{{demand.user.firstName}} {{demand.user.lastName}}</div>
                                                                            </div>
                                                                            <div class="div-block-27">
                                                                                <div v-if="demand.user.email" class="details-title">Contact Email:</div>
                                                                                <div class="text-block-10">{{demand.user.email}}</div>
                                                                            </div>
                                                                            <div class="div-block-27">
                                                                                <div v-if="demand.user.phoneNumber" class="details-title">Contact Phone:</div>
                                                                                <div class="text-block-10">{{demand.user.phoneNumber}}</div>
                                                                            </div>
                                                                            <div class="div-block-27">
                                                                                <div class="details-title">Delivery Location:</div>
                                                                                <div class="text-block-10">{{demand.requiredInState}}</div>
                                                                            </div>
                                                                            <div class="product-files-container">
                                                                                <div class="details-title">Related Product Files:</div>
                                                                                <span v-if="demand.msdsLink"><a href="#" class="product-file-link">{{demand.msdsLink}}</a></span>
                                                                                <span v-if="!demand.msdsLink">N/A</span>
                                                                            </div>
                                                                            <div class="contact">
                                                                                <div class="details-title">Request Description:</div>
                                                                                <div class="text-block-10">{{demand.description}}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="column-10 w-col w-col-6">
                                                                            <div class="supplier-logo-container">
                                                                                <a href="#" class="supplier-contact-logo w-inline-block">
                                                                                    <img width="401" :src="demand.user.account.logoUrl" :alt="demand.user.account.businessName" class="supplier-image">
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="manage-modal-form">
                                                                        <div>
                                                                            <input v-model="demandForm.qtyRequiredNow" v-mask="'########'" type="text" class="text-input w-input w-inline-input" placeholder="Change Requested Quantity" style="width: 200px; margin-right:5px">
                                                                            <input v-on:click="updateDemand(demand.id)" type="button" value="Update" data-wait="Please wait..." class="submit-button w-button" style="margin-right:5px">
                                                                            <input v-on:click="deleteDemand(demand.id)" type="button" value="Delete" data-wait="Please wait..." class="submit-button w-delete-button">
                                                                        </div>
                                                                        <div class="text-red" v-if="$v.demandForm.$error">
                                                                            <div>Please enter a value greater than zero</div>
                                                                        </div>
                                                                        <div class="form-fail" v-if="demandFail">
                                                                            <div>Oops! Something went wrong while submitting the change.</div>
                                                                        </div>
                                                                        <div class="input-container form-fail" v-if="demandValidation">
                                                                            <div>Please verify that everything you've entered is correct.</div>
                                                                        </div>
                                                                    </div>
                                                                    <modal v-if="demandSuccessModal && demandIndex === index" class="match-modal-wrapper" style="opacity: 1; display: flex;">
                                                                        <div class="mini-modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                                                            <div><h2>Success</h2></div>
                                                                            <div>Your request has been successfully modified.</div>
                                                                            <div class="mini-modal-button">
                                                                                <input v-on:click="refreshPage()" type="button" value="Continue" data-wait="Please wait..." class="submit-button w-button">
                                                                            </div>
                                                                        </div>
                                                                    </modal>
                                                                </div>
                                                            </div>
                                                        </modal>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="this.demandPosts.length == 0" id="requestedEmpty" class="no-items-found">
                                        <div>No items found.</div>
                                    </div>
                                </div>
                            </div>
                            <div data-w-tab="Tab 2" class="w-tab-pane w--tab-active" v-if="offersTab">
                                <div id="availableSuppliesTable" class="shortages-table">
                                    <div class="w-dyn-list">

                                        <div v-if="this.supplyPosts.length > 0" class="w-dyn-items">
                                            <div v-for="(supply, index) in this.supplyPosts" :key="supply.id" class="w-dyn-item">
                                                <div data-w-id="3bccb27c-24bb-5188-d8e8-d92e6fba3290" class="shortage-line-item top-item">
                                                    <div class="shortage-product-info">
                                                        <div class="div-block-24">
                                                            <div class="shortage-product">{{supply.product.description}}</div>
                                                            <div class="producttitle">{{getMaterialName(supply)}}</div>
                                                            <div class="div-block-32">
                                                                <div class="more-information-shortage">Supplied By: </div>

                                                                <div class="company-container">
                                                                    <div v-if="!supply.user.account.logoUrl" class="post-creator">{{supply.user.account.businessName}}</div>
                                                                    <img v-if="supply.user.account.logoUrl" height="18" :src="supply.user.account.logoUrl" :alt="supply.user.account.businessName" class="supplier-logo">
                                                                </div>
                                                                <div class="post-creator"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="offer-shortage-materials-container">
                                                        <div class="row-container">
                                                            <div class="available-units"></div>
                                                            <div class="product-units-available"></div>
                                                        </div><a href="#" v-on:click="manageOfferButtonClick(index)" class="offer-shortage-materials w-button">Manage Offer</a></div>
                                                    <modal v-if="offersModal && supplyIndex === index"  class="match-modal-wrapper" style="opacity: 1; display: flex;">
                                                        <div class="modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                                            <div class="modal-title-container">
                                                                <div>
                                                                    <div>{{supply.product.description}}</div>
                                                                    <div class="modal-header">{{getMaterialName(supply)}}</div>
                                                                    <div class="demand-container">
                                                                        <div>Available:</div>
                                                                        <div class="supply">{{supply.qtyAvailableNow}} {{getUnits(supply)}}</div>
                                                                    </div>
                                                                </div>
                                                                <div v-on:click="manageOfferButtonClick()" data-w-id="0f61cdc8-0f02-cc9b-58cd-fab5413d5186" class="close-available-modal-button"><img src="../assets/images/close.png" alt=""></div>
                                                            </div>
                                                            <div class="supplier-information-container">
                                                                <div class="columns-5 w-row">
                                                                    <div class="column-9 w-col w-col-6">
                                                                        <div class="div-block-27">
                                                                            <div class="details-title">Supplier:</div>
                                                                            <div class="text-block-10">{{supply.user.account.businessName}}</div>
                                                                        </div>
                                                                        <div class="div-block-27">
                                                                            <div class="details-title">Contact:</div>
                                                                            <div class="text-block-10">{{supply.user.firstName}} {{supply.user.lastName}}</div>
                                                                        </div>
                                                                        <div v-if="supply.user.email" class="div-block-27">
                                                                            <div class="details-title">Contact Email:</div>
                                                                            <div class="text-block-10">{{supply.user.email}}</div>
                                                                        </div>
                                                                        <div v-if="supply.user.phoneNumber" class="div-block-27">
                                                                            <div class="details-title">Contact Phone:</div>
                                                                            <div class="text-block-10">{{supply.user.phoneNumber}}</div>
                                                                        </div>
                                                                        <div class="div-block-27">
                                                                            <div class="details-title">Delivers to:</div>
                                                                            <div class="text-block-10">{{supply.deliveredToState}}</div>
                                                                        </div>
                                                                        <div class="div-block-27">
                                                                            <div class="details-title">Offer Description:</div>
                                                                            <div class="text-block-10">{{supply.description}}</div>
                                                                        </div>
<!--                                                                        <div class="div-block-27">-->
<!--                                                                            <div class="details-title">Minimum Order:</div>-->
<!--                                                                            <div class="deliveryprovinces"></div>-->
<!--                                                                        </div>-->
<!--                                                                        <div class="div-block-27">-->
<!--                                                                            <div class="details-title">Average Unit Price (Min. Order):</div>-->
<!--                                                                            <div class="deliveryprovinces">{{supply.averageCostPerUnit}}</div>-->
<!--                                                                        </div>-->
<!--                                                                        <div class="div-block-27">-->
<!--                                                                            <div class="details-title">Weekly Production Rate:</div>-->
<!--                                                                            <div class="deliveryprovinces">{{supply.qtyProducedIn5Days}}</div>-->
<!--                                                                        </div>-->
                                                                    </div>
                                                                    <div class="column-10 w-col w-col-6">
                                                                        <div class="supplier-logo-container">
                                                                            <a href="#" class="supplier-contact-logo w-inline-block">
                                                                                <img width="401" :src="supply.user.account.logoUrl" :alt="supply.user.account.businessName" class="supplier-image">
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="manage-modal-form">
                                                                    <div>
                                                                        <input v-model="supplyForm.qtyAvailableNow" v-mask="'########'" type="text" class="text-input w-input w-inline-input" placeholder="Set Remaining Quantity" style="width: 200px; margin-right:5px">
                                                                        <input v-on:click="updateSupply(supply.id)" type="button" value="Update" data-wait="Please wait..." class="submit-button w-button" style="margin-right:5px">
                                                                        <input v-on:click="deleteSupply(supply.id)" type="button" value="Delete" data-wait="Please wait..." class="submit-button w-delete-button">
                                                                    </div>
                                                                    <div class="text-red" v-if="$v.supplyForm.$error">
                                                                        <div>Please enter a value greater than zero</div>
                                                                    </div>
                                                                    <div class="form-fail" v-if="supplyFail">
                                                                        <div>Oops! Something went wrong while submitting the change.</div>
                                                                    </div>
                                                                    <div class="input-container form-fail" v-if="supplyValidation">
                                                                        <div>Please verify that everything you've entered is correct.</div>
                                                                    </div>
                                                                </div>
                                                                <modal v-if="supplySuccessModal && supplyIndex === index" class="match-modal-wrapper" style="opacity: 1; display: flex;">
                                                                    <div class="mini-modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                                                        <div><h2>Success</h2></div>
                                                                        <div>Your offer has been successfully modified.</div>
                                                                        <div class="mini-modal-button">
                                                                            <input v-on:click="refreshPage()" type="button" value="Continue" data-wait="Please wait..." class="submit-button w-button">
                                                                        </div>
                                                                    </div>
                                                                </modal>
                                                            </div>
                                                        </div>
                                                    </modal>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="this.supplyPosts.length == 0" id="availableEmpty" class="no-items-found">
                                        <div>No items found.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {accountService} from "../assets/js/services/accountService";
    import {required, minValue} from "vuelidate/lib/validators";
    import {manageService} from "../assets/js/services/manageService";
    //import {router} from "../assets/js/helpers/router";

    export default {
        name: "MyPosts",
        created () {
            document.title = "My Posts - Manufacturer";
            this.getDemandPosts()
            this.getSupplyPosts();
            this.demandIndex = undefined;
            this.supplyIndex = undefined;
        },
        data () {
            return {
                demandTab: true,
                offersTab: false,
                demandModal: false,
                offersModal: false,
                demandPosts: "",
                supplyPosts: "",
                supplyForm: {
                    qtyAvailableNow: "",
                },
                demandForm: {
                    qtyRequiredNow: "",
                },
                supplySuccess: false,
                supplySuccessModal: false,
                supplyFail: false,
                supplyValidation: false,
                demandSuccess: false,
                demandSuccessModal: false,
                demandFail: false,
                demandValidation: false,
                supplyFormError: false,
                demandFormError: false,
            }
        },
        methods: {
            getSupplyPosts () {
                accountService.getSupplyPosts().then((response) => {
                    this.success = true;
                    this.supplyPosts = response.content.content;
                    console.log("Supply");
                    console.log(this.supplyPosts);
                }).catch((error) => {
                    console.log(error);
                    this.fail = true;
                });
            },
            getDemandPosts () {
                accountService.getDemandPosts().then((response) => {
                    this.success = true;
                    this.demandPosts = response.content.content;
                    console.log("Demand");
                    console.log(this.demandPosts);
                }).catch((error) => {
                    console.log(error);
                    this.fail = true;
                });
            },
            requestsTabClick () {
                this.demandTab = true;
                this.offersTab = false;
                this.demandModal = false;
                this.offersModal = false;
            },
            offersTabClick () {
                this.demandTab = false;
                this.offersTab = true;
                this.demandModal = false;
                this.offersModal = false;
            },
            clearForm () {
                this.demandForm.qtyRequiredNow = "";//Reset the forms, just in case
                this.supplyForm.qtyAvailableNow = "";
            },
            manageRequestButtonClick (index) {//Demand
                this.clearForm();
                this.demandIndex = index;
                this.demandModal = !this.demandModal;
            },
            manageOfferButtonClick (index) {//Supply
                this.clearForm();
                this.supplyIndex = index;
                this.offersModal = !this.offersModal;
            },
            showDemandSuccessModal () {
                this.demandSuccessModal = true;
            },
            showSupplySuccessModal () {
                this.supplySuccessModal = true;
            },
            getMaterialName: function (request) {
                if (request.material) {
                    if (request.material.materialName === "Other") {
                        return request.otherMaterialName + "(" + request.material.materialName + ")";
                    }
                    return request.material.materialName;
                }
                return request.product ? "Finished Units" : ""
            },
            getUnits: function (request) {
                return request.material ? request.material.unitOfMeasure : "units";
            },
            refreshPage (){//Because route.push("my-posts") is not allowed. For some reason.
                this.supplySuccessModal = false;
                this.demandSuccessModal = false;
                this.demandModal = false;
                this.offersModal = false;
                this.supplySuccess = false;
                this.supplyFail = false;
                this.supplyValidation = false;
                this.demandSuccess = false;
                this.demandFail = false;
                this.demandValidation = false;
                this.supplyForm.qtyAvailableNow = "";
                this.demandForm.qtyRequiredNow = "";
                this.supplyFormError = false;
                this.demandFormError = false;
                this.$v.supplyForm.$reset();
                this.$v.demandForm.$reset();
                this.getDemandPosts();
                this.getSupplyPosts();
            },
            updateSupply (id) {
                this.$v.supplyForm.$touch();
                if(this.$v.supplyForm.$error){
                    this.supplyFormError = true;
                    return;
                }

                console.log(id);
                console.log(this.supplyForm);
                console.log(this.supplyForm.qtyAvailableNow);

                manageService.updateSupply(id, this.supplyForm.qtyAvailableNow).then(() => {
                    this.supplySuccess = true;
                    this.showSupplySuccessModal();
                }).catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.supplyValidation = true;
                            console.log(error.content);
                        }
                        else {
                            this.supplyFail = true;
                        }
                    });
            },
            updateDemand (id) {
                this.$v.demandForm.$touch();
                if(this.$v.demandForm.$error){
                    this.demandFormError = true;
                    return;
                }

                console.log(id);
                console.log(this.demandForm);
                console.log(this.demandForm.qtyRequiredNow);

                manageService.updateDemand(id, this.demandForm.qtyRequiredNow).then(() => {
                    this.demandSuccess = true;
                    this.showDemandSuccessModal();
                }).catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.demandValidation = true;
                            console.log(error.content);
                        }
                        else {
                            this.demandFail = true;
                        }
                    });

            },
            deleteSupply (id) {
                console.log(id);
                manageService.deleteSupply(id).then(() => {
                    this.supplySuccess = true;
                    this.showSupplySuccessModal();
                })
                    .catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.supplyValidation = true;
                            console.log(error.content);
                        }
                        else {
                            this.supplyFail = true;
                        }
                    });
            },
            deleteDemand (id) {
                console.log(id);
                manageService.deleteDemand(id).then(() => {
                    this.demandSuccess = true;
                    this.showDemandSuccessModal();
                }).catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.demandValidation = true;
                            console.log(error.content);
                        }
                        else {
                            this.demandFail = true;
                        }
                    });
            }
        },
        validations: {
            demandForm: {
                qtyRequiredNow: {required, minValue: minValue(1)},
            },
            supplyForm: {
                qtyAvailableNow: {required, minValue: minValue(1)},
            }
        }
    }
</script>

<style scoped>

</style>
